import { Layout } from '../components/layout/';
import { ButtonLink } from '../components/ButtonLink.jsx';
import { GlobalPage } from '../components/GlobalPage.jsx';
import { MoneyInput } from '../components/MoneyInput.jsx';
import { Article } from '../components/articles/Article.jsx';
import { SubmitButton } from '../components/SubmitButton.jsx';
import { CheckboxInput } from '../components/CheckboxInput.jsx';
import { PostalCodeInput } from '../components/PostalCodeInput.jsx';
import { RadioButtonGroup } from '../components/RadioButtonGroup.jsx';
import { InterestRateInput } from '../components/InterestRateInput.jsx';

export default function ComponentLibraryPage() {
  return (
    <GlobalPage
      title="Compontent Library"
      description="Compontent Library"
      canonical="/component-library"
      noIndex={true}
    >
      <Layout>
        <Article headline="Component Library (ish)">
          <h2>MoneyInput</h2>
          <div>
            <MoneyInput
              label="Label"
              onChange={() => console.log('MoneyInput change')}
            />
            <pre>{`<MoneyInput
  label="Label"
  onChange={() => console.log('MoneyInput change')}
/>`}</pre>
          </div>
          <h2>InterestRateInput</h2>
          <div>
            <InterestRateInput
              label="Label"
              onChange={() => console.log('InterestRateInput change')}
            />
            <pre>{`<InterestRateInput
  label="Label"
  onChange={() => console.log('InterestRateInput change')}
/>`}</pre>
          </div>
          <h2>PostalCodeInput</h2>
          <div>
            <PostalCodeInput
              label="Label"
              onChange={() => console.log('PostalCodeInput change')}
            />
            <pre>{`<PostalCodeInput
  label="Label"
  onChange={() => console.log('PostalCodeInput change')}
/>`}</pre>
          </div>
          <h2>CheckboxInput</h2>
          <div>
            <CheckboxInput
              label="Label"
              text="Text"
              onChange={() => console.log('CheckboxInput change')}
            />
            <pre>{`<CheckboxInput
  label="Label"
  text="Text"
  onChange={() => console.log('CheckboxInput change')}
/>`}</pre>
          </div>
          <h2>ButtonLink</h2>
          <div>
            <ButtonLink href="/component-library">Text</ButtonLink>
            <pre>{`<ButtonLink
  href="/component-library"
>
  Text
</ButtonLink>`}</pre>
          </div>
          <h2>SubmitButton</h2>
          <div>
            <SubmitButton level="primary">Here goes text</SubmitButton>
            <pre>{`<SubmitButton
  level="primary"
>
  Here goes text
</SubmitButton>`}</pre>
          </div>
          <h2>SubmitButton (loading)</h2>
          <div>
            <SubmitButton
              level="secondary"
              isLoading={true}
              loadingLabel="Loading..."
            >
              Here goes text
            </SubmitButton>
            <pre>{`<SubmitButton
  level="secondary"
  isLoading={true}
  loadingLabel="Loading..."
>
  Here goes text
</SubmitButton>`}</pre>
          </div>
          <h2>RadioButtonGroup</h2>
          <div>
            <RadioButtonGroup
              label="Label"
              helperText="Helper Text"
              buttons={[
                { key: 'foo', value: 'Foo' },
                { key: 'bar', value: 'Bar' },
                { key: 'baz', value: 'Baz' },
              ]}
              defaultKey="foo"
              onChange={() => console.log('RadioButtonGroup change')}
            />
            <pre>{`<RadioButtonGroup
  label="Label"
  helperText="Helper Text"
  buttons={[
    { key: 'foo', value: 'Foo' },
    { key: 'bar', value: 'Bar' },
    { key: 'baz', value: 'Baz' },
  ]}
  defaultKey="foo"
  onChange={() => console.log('RadioButtonGroup change')}
/>`}</pre>
          </div>
        </Article>
      </Layout>
    </GlobalPage>
  );
}
